<style lang="scss">
.Change-pwd-safe .remind {
  text-align: center;
  color: #cccccc;
}

.Change-pwd-safe .bombbox {
  width: 410px;
  box-sizing: border-box;
  border-radius: 10px;
  .el-dialog__body {
    box-sizing: border-box;
    width: 410px;
  }
}

.Change-pwd-safe .input-form {
  margin-top: 20px;
  padding: 0 73px;
}

/* @media (min-width: 768px) {
        .Change-pwd-safe .bombbox {
            width: 410px;
        }

        .Change-pwd-safe .input-form {
            padding: 0 50px;
        }
    } */

.Change-pwd-safe .yan-zh {
  width: 146px;
}

.Change-pwd-safe .get-button {
  text-align: center;
  width: 70px;
}

.Change-pwd-safe .que-button {
  width: 120px;
}

.Change-pwd-safe .footer {
  text-align: center;
}
</style>
<template>
  <div class="Change-pwd-safe">
    <el-dialog :title="box_title" :visible.sync="myResult" label-width="0px" custom-class="bombbox">
      <div class="remind" v-if="change_pwd">确保更改绑定操作属用户本人操作</div>
      <div class="remind" v-else>重置密码后将退出重新登录</div>
      <div v-if="change_pwd">
        <el-form :model="form1" ref="form1" class="input-form" :rules="form1_rules">
          <el-form-item>
            <el-select
              v-model="value"
              placeholder="请选择安全验证方式"
              style="width: 100%"
              @change="changeValidateWay"
            >
              <el-option label="通过登录密码验证" value="1"></el-option>
              <el-option :label="'通过手机号'+phone+'验证'" value="2" v-if="phone"></el-option>
              <el-option :label="'通过邮箱'+email+'验证'" value="3" v-if="email"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="xx">
            <el-input
              v-model="form1.xx"
              :placeholder="xx_message"
              :class="{'yan-zh': value==2||value==3}"
              :type="value==1?'password':'text'"
            ></el-input>
            <el-button
              type="text"
              class="get-button AEE-tc"
              v-if="value==2"
              @click="getCaptcha"
              :disabled="phone_pb_disabled"
            >{{ phone_pb_show}}</el-button>
            <el-button
              type="text"
              class="get-button AEE-tc"
              v-if="value==3"
              @click="getCaptcha"
              :disabled="email_pb_disabled"
            >{{ email_pb_show}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <el-form :model="form2" ref="form2" class="input-form" :rules="form2_rules">
          <el-form-item prop="pwd">
            <el-input type="password" v-model="form2.pwd" placeholder="设置密码"></el-input>
          </el-form-item>
          <el-form-item prop="c_pwd">
            <el-input type="password" v-model="form2.c_pwd" placeholder="确认密码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button
          type="primary"
          size="large"
          class="que-button"
          @click="safeValidate"
          v-if="change_pwd"
        >验证身份</el-button>
        <el-button type="primary" size="large" class="que-button" @click="postPwd" v-else>确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data: function() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!/^[a-zA-Z\d]{6,26}$/.test(value)) {
        callback(new Error("请输入6-26位数字或字母"));
      } else {
        if (this.form2.c_pwd !== "") {
          this.$refs.form2.validateField("c_pwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.pwd_code_message != "") {
        callback(getErrorMessage(this.pwd_code_message));
        this.pwd_code_message = "";
      } else if (value !== this.form2.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validateXx = (rule, value, callback) => {
      if (this.value == 1) {
        if (value == "") {
          callback("请输入密码");
        } else if (value.length < 6 && value.length > 26) {
          callback(new Error("请输入6-26位数字或字母"));
        } else if (this.xx_code_message != "") {
          callback(getErrorMessage(this.xx_code_message));
          this.xx_code_message = "";
        } else {
          callback();
        }
      } else {
        if (value == "") {
          callback("请输入动态码");
        }
        if (this.xx_code_message != "") {
          callback(getErrorMessage(this.xx_code_message));
          this.xx_code_message = "";
        } else {
          callback();
        }
      }
    };
    return {
      form1: {
        xx: ""
      },
      form2: {
        pwd: "",
        c_pwd: ""
      },
      form1_rules: {
        xx: [{ required: true, validator: validateXx, trigger: "change" }]
      },
      form2_rules: {
        pwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        c_pwd: [{ required: true, validator: validatePass2, trigger: "blur" }]
      },
      value: "1",
      xx_code_message: "",
      pwd_code_message: "",
      myResult: this.dialogFormVisible,
      captcha_token: "",
      box_title: "安全验证",
      change_pwd: true,
      phone_pb_disabled: false,
      phone_pb_show: "获取验证码",
      email_pb_disabled: false,
      email_pb_show: "获取验证码"
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    email: String,
    phone: String
  },
  watch: {
    dialogFormVisible(val) {
      this.myResult = val;
    },
    myResult(val) {
      this.change_pwd = true;
      this.box_title = "安全验证";
      if (this.$refs.form1 != null) this.$refs.form1.resetFields();
      if (this.$refs.form2 != null) this.$refs.form2.resetFields();
      this.$emit("on-result-change", val);
    }
  },
  methods: {
    changeValidateWay: function() {
      this.form1.xx = null;
      if (this.$refs.form1 != null) this.$refs.form1.resetFields();
    },
    safeValidate: function() {
      if (this.value == 1) {
        this.$refs.form1.validate(valid => {
          if (valid) {
            this.$http
              .post(globalProvider.serviceUrl("ea/md/p/sfck/v/p"), {
                pwd: this.form1.xx
              })
              .then(data => {
                if (data.body.code == resultCode.Success) {
                  this.captcha_token = data.body.data;
                  this.box_title = "设置密码";
                  this.change_pwd = false;
                } else if (data.body.code == resultCode.NotSuccess) {
                  this.xx_code_message = data.body.message;
                  this.$refs.form1.validateField("xx");
                }
              });
          }
        });
      } else if (this.value == 2) {
        this.$refs.form1.validate(valid => {
          if (valid) {
            this.$http
              .post(globalProvider.serviceUrl("ea/v/md/p/sfck/dc/m"), {
                ac: this.phone,
                dc: this.form1.xx
              })
              .then(data => {
                if (data.body.code == resultCode.Success) {
                  this.captcha_token = data.body.data;
                  this.box_title = "设置密码";
                  this.change_pwd = false;
                } else if (data.body.code == resultCode.NotSuccess) {
                  this.xx_code_message = data.body.message;
                  this.$refs.form1.validateField("xx");
                }
              });
          }
        });
      } else if (this.value == 3) {
        this.$refs.form1.validate(valid => {
          if (valid) {
            this.$http
              .post(globalProvider.serviceUrl("ea/v/md/p/sfck/dc/e"), {
                ac: this.email,
                dc: this.form1.xx
              })
              .then(data => {
                if (data.body.code == resultCode.Success) {
                  this.captcha_token = data.body.data;
                  this.box_title = "设置密码";
                  this.change_pwd = false;
                } else if (data.body.code == resultCode.NotSuccess) {
                  this.xx_code_message = data.body.message;
                  this.$refs.form1.validateField("xx");
                }
              });
          }
        });
      }
    },
    getCaptcha: function() {
      if (this.value == 2) {
        this.$http
          .post(globalProvider.serviceUrl("ea/md/p/sfck/c/dc/m"), {
            ac: this.phone,
            kv: {
              考试名称: this.$store.state.examInfo.currentExamInfo.exam_name
            }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              this.phone_pb_disabled = true;
              let time = 60;
              this.phone_pb_show = time + 1;
              for (let i = 0; i <= time; i++) {
                window.setTimeout(() => {
                  --this.phone_pb_show;
                  if (this.phone_pb_show == 0) {
                    this.phone_pb_show = "重新发送";
                    this.phone_pb_disabled = false;
                    this.captchaUrl =
                      serviceUrl + "ea/tt/vc/" + this.captcha_token;
                  }
                }, i * 1000);
              }
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message), "提示信息", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          });
      } else if (this.value == 3) {
        this.$http
          .post(globalProvider.serviceUrl("ea/md/p/sfck/c/dc/e"), {
            ac: this.email
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              this.email_pb_disabled = true;
              let time = 60;
              this.email_pb_show = time + 1;
              for (let i = 0; i <= time; i++) {
                window.setTimeout(() => {
                  --this.email_pb_show;
                  if (this.email_pb_show == 0) {
                    this.email_pb_show = "重新发送";
                    this.email_pb_disabled = false;
                    this.captchaUrl =
                      serviceUrl + "ea/tt/vc/" + this.captcha_token;
                  }
                }, i * 1000);
              }
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message), "提示信息", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          });
      }
    },
    postPwd: function() {
      this.$refs.form2.validate(valid => {
        if (valid) {
          this.$http
            .post(globalProvider.serviceUrl("ea/md/p"), {
              n_p: this.form2.pwd,
              tk: this.captcha_token
            })
            .then(data => {
              if (data.body.code == resultCode.Success) {
                this.myResult = false;
                this.$alert("修改密码成功", "提示", {
                  confirmButtonText: "确定",
                  callback: function(action) {}
                });
              } else if (data.body.code == resultCode.NotSuccess) {
                this.pwd_code_message = data.body.message;
                this.$refs.form2.validateField("c_pwd");
              }
            });
        }
      });
    }
  },
  computed: {
    xx_message: function() {
      if (this.value == 1) {
        return "登录密码";
      } else if (this.value == 2) {
        return "短信验证码";
      } else if (this.value == 3) {
        return "邮箱验证码";
      }
    }
  }
};
</script>